module.exports = __webpack_public_path__ + "pcph/img/whoworld.87427d80.png";